import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Icon } from 'antd';
import { NEW_TEMPLATE_SECTION } from './translationValues';

const TagSearchContainer = styled.div`
  background: #f9fafb;
  border-radius: 16px;
  padding: 16px;
  border: 1px solid #e5e7eb;
`;

const TagsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: ${props => (props.hasItems ? '12px' : '0')};
`;

const TagBadge = styled.div`
  background: linear-gradient(to right, #6366f1, #a855f7);
  color: white;
  padding: 8px 16px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
`;

const RemoveButton = styled.button`
  width: 20px;
  height: 20px;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
  }

  svg {
    color: white;
  }
`;

const InputWrapper = styled.div`
  position: relative;
`;

const StyledInput = styled.input`
  width: 100%;
  background: white;
  border: 1px solid #d1d5db;
  border-radius: 12px;
  padding: 10px 16px;
  font-size: 14px;
  outline: none;
  transition: all 0.2s;

  &::placeholder {
    color: #9ca3af;
  }

  &:focus {
    border-color: #6366f1;
    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
  }
`;

export function TagSearch({ selectedTags, onTagsChange }) {
  const { t } = useTranslation(['NEW_TEMPLATE_SECTION']);
  const [inputValue, setInputValue] = useState('');

  const addTag = tag => {
    if (!selectedTags.includes(tag)) {
      onTagsChange([...selectedTags, tag]);
    }
    setInputValue('');
  };

  const removeTag = tagToRemove => {
    onTagsChange(selectedTags.filter(tag => tag !== tagToRemove));
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter' && inputValue.trim()) {
      addTag(inputValue.trim().toLowerCase());
    }
  };

  return (
    <TagSearchContainer>
      {/* Selected Tags */}
      {selectedTags.length > 0 && (
        <TagsWrapper hasItems={true}>
          {selectedTags.map(tag => (
            <TagBadge key={tag}>
              <span>{tag}</span>
              <RemoveButton onClick={() => removeTag(tag)}>
                <Icon type="close" size={12} />
              </RemoveButton>
            </TagBadge>
          ))}
        </TagsWrapper>
      )}

      {/* Search Input */}
      <InputWrapper>
        <StyledInput
          value={inputValue}
          onChange={e => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={t(
            NEW_TEMPLATE_SECTION.PLACEHOLDER_SEARCH_BY_TAGS.key,
            NEW_TEMPLATE_SECTION.PLACEHOLDER_SEARCH_BY_TAGS.value,
          )}
        />
      </InputWrapper>
    </TagSearchContainer>
  );
}
